<template>
  <div class="app-content">
    <p class="login-title">Hi，老板</p>
    <p class="login-title">
      欢迎使用
      <span class="logo">iCompany</span>
    </p>
    <div class="form-box">
      <div class="input-box">
        <input type="text" v-model="regForm.username" placeholder="请输入手机号" />
      </div>
      <div class="input-box">
        <input type="text" v-model="regForm.imgCode" placeholder="请输入图片验证码" />
        <img class="img-code" :src="codeUrl" alt="" @click="getImgCode" />
      </div>
      <div class="input-box">
        <input type="text" v-model="regForm.code" placeholder="请输入验证码" />
        <button class="sms-code" @click="smsClick">{{ smsText }}</button>
      </div>
      <div class="input-box">
        <input type="password" v-model="regForm.password" placeholder="请输入密码" />
      </div>
      <div class="xieyi clearfix">
        注册即表示已阅读并同意
        <router-link to="/enterpriseSpecialH5/agreement">
          <span class="xieyi-style">《icompany用户协议》</span>
        </router-link>
      </div>
      <button class="login-btn" @click="handleReg">注册</button>
    </div>
  </div>
</template>
<script>
import { reg, getCodeImg, sentSmsCode } from '@/api/login'
import { getDeviceId } from '@/utils'
export default {
  data() {
    return {
      current: 0,
      smsText: '获取验证码',
      smsTime: 60,
      regForm: {
        code: '',
        username: '',
        password: '',
        uuid: '',
        imgCode: '',
      },
      codeUrl: '',
    }
  },
  created() {
    this.getImgCode()
  },
  methods: {
    getImgCode() {
      getCodeImg().then((res) => {
        this.codeUrl = 'data:image/gif;base64,' + res.img
        this.regForm.uuid = res.uuid
      })
    },
    smsClick() {
      if (this.regForm.username == '') {
        this.$toast('请输入手机号')
        return false
      }
      // 发送验证码请求
      const type = 'reg'
      sentSmsCode(this.regForm.username, type, this.regForm.uuid, this.regForm.imgCode).then((res) => {
        console.log(res, 'res')
        if (res.code == 200) {
          this.isDisabled = true
          this.smsText = this.smsTime + 's'
          --this.smsTime
          const interval = window.setInterval(() => {
            this.smsText = this.smsTime + 's'
            --this.smsTime
            if (this.smsTime < 0) {
              this.smsText = '重新发送'
              this.smsTime = 60
              this.isDisabled = false
              window.clearInterval(interval)
            }
          }, 1000)
          this.regForm.uuid = res.uuid
        } else {
          this.$toast(res.message)
        }
      })
    },
    handleReg() {
      reg(
        this.regForm.username,
        this.regForm.password,
        this.regForm.code,
        this.regForm.uuid,
        1 // 注册来源
      )
        .then((res) => {
          if (res.code == 200) {
            const orgInfo = res.tuserDTO.orgList[0]
            const tel = res.tuserDTO.mobile
            const uid = res.tuserDTO.id
            const cid = orgInfo.organizationId
            const loginFrom = sessionStorage.getItem('loginFrom')
            // 设置 参数
            sessionStorage.setItem('tenant', 'tog')
            sessionStorage.setItem('page', 'ICompany')
            sessionStorage.setItem('cid', cid)
            sessionStorage.setItem('corp', '')
            sessionStorage.setItem('uid', uid)
            sessionStorage.setItem('tel', tel)
            sessionStorage.setItem('deviceId', getDeviceId())
            sessionStorage.setItem('clientType', 'H5')
            this.$toast({ type: 'success', message: '登录成功' })

            if (loginFrom === 'littleGiant') {
              this.$router.replace('/enterpriseSpecialH5/littleGiant/result')
            } else {
              this.$router.replace('/enterpriseSpecialH5/smEvaluation/result')
            }
          } else {
            this.$toast({ type: 'fail', message: res.message })
          }
        })
        .catch(() => {
          this.$toast({ type: 'fail', message: '注册失败' })
        })
    },
  },
}
</script>
<style lang="less" scoped>
.app-content {
  padding: 0.58rem 0.6rem;
  .login-title {
    color: #484848;
    font-size: 0.48rem;
    font-weight: 600;
    line-height: 0.8rem;
    .logo {
      color: #118ee9;
    }
  }
  .tabs {
    margin-top: 1.46rem;
  }
  .form-box {
    margin-top: 1.44rem;
    .input-box {
      border-bottom: 1px solid #e3e3e3;
      position: relative;
      .img-code {
        position: absolute;
        right: 0;
        top: 0.15rem;
      }
      input {
        background: none;
        border: none;
        outline: none;
        height: 1rem;
        line-height: 1rem;
        font-size: 0.28rem;
        padding: 0;
        margin-bottom: 0;
      }
      input::-webkit-input-placeholder {
        /* Chrome/Opera/Safari */
        color: #c5c5c5;
        font-size: 0.28rem;
      }
      input::-moz-placeholder {
        /* Firefox 19+ */
        color: #c5c5c5;
        font-size: 0.28rem;
      }
      input:-ms-input-placeholder {
        /* IE 10+ */
        color: #c5c5c5;
        font-size: 0.28rem;
      }
      input:-moz-placeholder {
        /* Firefox 18- */
        color: #c5c5c5;
        font-size: 0.28rem;
      }
      .sms-code {
        background-color: #f5f5f5;
        color: #797979;
        font-size: 0.28rem;
        width: 1.7rem;
        height: 0.7rem;
        line-height: 0.7rem;
        position: absolute;
        right: 0;
        top: 0.15rem;
        padding: 0;
        border-radius: 0.06rem;
      }
    }
    .login-btn {
      background-color: #118ee9;
      color: #fff;
      width: 100%;
      line-height: 0.9rem;
      border-radius: 8px;
      margin-top: 0.6rem;
      padding: 0;
    }
    .btn-box {
      margin-top: 0.3rem;
      color: #999999;
      font-size: 0.28rem;
      div {
        cursor: pointer;
      }
    }
  }
  .xieyi {
    font-size: 0.24rem;
    color: #797979;
    text-align: center;
    margin-top: 0.3rem;
    .xieyi-style {
      color: #118ee9;
    }
  }
  button {
    margin: 0;
    border: 1px solid transparent;
    outline: none;
  }
}
</style>
